module.exports = {
	apiURL: 'https://odedim-api.pstv.co/',
	cdnUrl: 'https://odedim-api.pstv.co/_docs/',
	captchaSiteKey: '6LeNrcYZAAAAAM3X3wngBa39vpl511ACfxVf91Y_',

	// apiURL: 'https://api.odedim.com/',
	// cdnUrl: 'https://cdnd.odedim.com/',
}